import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import React from "react";
import ReactDOM from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { BrowserRouter } from "react-router-dom";
import App from "./App.tsx";
import { AuthProvider } from "./contexts/AuthContext.tsx";
import { CollapseDrawerProvider } from "./contexts/CollapseDrawerContext.tsx";
import { SettingsProvider } from "./contexts/SettingsContext.tsx";
import { PermissionsProvider } from "./contexts/PermissionsContext.tsx";
import { ViabilityLockProvider } from "./contexts/TrendViabilityLockContext.tsx";
import { BrandComparisonProvider } from "./contexts/BrandComparisonContext.tsx";
import { BrandMappingProvider } from "./contexts/BrandMappingContext.tsx";
import { BrandMappingProviderV2 } from "./contexts/BrandMappingContextV2.tsx";
import { BrandMappingProviderV3 } from "./contexts/BrandMappingContextV3.tsx";
import * as Sentry from "@sentry/react";
import { setupSentryErrorFilter } from "./api/common/api";
import './i18n';

// Initialize Sentry
Sentry.init({
  dsn: "https://1339f0903fdc40cf9b1b0655f191b8dd@o1092163.ingest.us.sentry.io/4504137219964928",
  integrations: [],
});

// Set up error filter for canceled requests
setupSentryErrorFilter();

ReactDOM.createRoot(document.getElementById("root") as HTMLElement).render(
  <React.StrictMode>
    <AuthProvider>
      <PermissionsProvider>
        <BrandComparisonProvider>
          <BrandMappingProvider>
            <BrandMappingProviderV2>
              <BrandMappingProviderV3>
                <ViabilityLockProvider>
                  <HelmetProvider>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <SettingsProvider>
                        <CollapseDrawerProvider>
                          <BrowserRouter>
                            <App />
                          </BrowserRouter>
                        </CollapseDrawerProvider>
                      </SettingsProvider>
                    </LocalizationProvider>
                  </HelmetProvider>
                </ViabilityLockProvider>
              </BrandMappingProviderV3>
            </BrandMappingProviderV2>
          </BrandMappingProvider>
        </BrandComparisonProvider>
      </PermissionsProvider>
    </AuthProvider>
  </React.StrictMode>,
);
